import { render } from "./ClassAddPage.vue?vue&type=template&id=6e874454"
import script from "./ClassAddPage.vue?vue&type=script&lang=js"
export * from "./ClassAddPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__